<template>
  <div class="order-query">
    <header class="page-header">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ title }}</span>
      <span></span>
    </header>
    <main class="page-body">
      <div class="flexbox">
        <van-search
          class="flex-fill"
          v-model="keyword"
          :placeholder="$t('单号/唛头/物品名称')"
          @search="onSearch"
        />
      </div>
      <van-tabs v-model="active" @click="onSearch">
        <van-tab :title="$t('待入库')" :badge="stats.pkg_OutStock"></van-tab>
        <van-tab :title="$t('已入库')" :badge="stats.pkg_InStock"></van-tab>
        <van-tab :title="$t('已发货')" :badge="stats.pkg_Sended"></van-tab>
        <van-tab :title="$t('Orders.cbi5ag')"></van-tab>
        <van-tab
          :title="$t('Orders.yrfvav')"
          :badge="stats.pkg_Problem"
        ></van-tab>
      </van-tabs>
      <div
        class="van-cell  van-field"
        style="border-bottom: 1px solid #efefef;"
      >
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <input type="date" v-model="startDate" class="date-input" />
          </div>
        </div>
        <div
          class="van-cell__title van-field__label"
          style="text-align: center;"
        >
          -
        </div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <input type="date" v-model="endDate" class="date-input" />
          </div>
        </div>
      </div>
      <section v-if="list.length > 0">
        <section class="list padding" :style="[bodyHeight]">
          <div class="card" v-for="(item, index) in list" :key="index">
            <template>
              <div
                class="card-body flexbox space-bt"
                @click="
                  $router.push({
                    name: 'PackageEdit',
                    query: { id: item.PK_ID },
                  })
                "
              >
                <div>
                  <div>
                    {{ $t('Package.快递单号') }}：{{ item.delivery_no | empty }}
                  </div>
                  <div>
                    {{ $t('Package.唛头') }}：{{ item.sShippingMark | empty }}
                  </div>
                  <div>{{ $t('Package.箱号') }}：{{ item.sBagNo | empty }}</div>
                  <div>
                    {{ $t('Package.进仓时间') }}：{{ item.createtime | empty }}
                  </div>
                  <div>{{ $t('Package.物品名称') }}：{{ item.goods_name }}</div>
                  <div>
                    {{ $t('Package.英文名称') }}：{{ item.sEnGoodName }}
                  </div>
                  <div>
                    {{ $t('Package.进仓编号') }}：{{ item.sCode | empty }}
                  </div>
                  <div>
                    {{ $t('ETD') }}：{{ item.dActualDepartDate | empty }}
                  </div>
                  <div>
                    {{ $t('ETA') }}：{{ item.dActualArriveDate | empty }}
                  </div>
                  <div v-if="appTitle != 'Love Logistic'">
                    <div>
                      {{ $t('Package.订单编号') }}：{{ item.OrderNo | empty }}
                    </div>
                    <div>
                      {{ $t('Package.单个货值') }}：{{
                        item.single_price | empty
                      }}
                    </div>
                    <div>
                      {{ $t('Package.整体货值') }}：{{
                        item.fDeclareAmount_LC | empty
                      }}
                    </div>
                  </div>
                  <div v-if="active == 2">
                    ETD：{{ item.dDepartTime | empty }}
                  </div>
                  <div v-if="active == 2">
                    ETA：{{ item.dArriveTime | empty }}
                  </div>
                </div>
                <img
                  @click="onImgPreview(item.sPicUrl)"
                  :src="
                    item.sPicUrl == '' || item.sPicUrl == null
                      ? emptyImg
                      : item.sPicUrl
                  "
                  alt=""
                  :class="item.sPicUrl == '' ? 'noimg' : 'img'"
                />
              </div>
              <van-image
                class="van-image-qsoa"
                v-for="(imgItem, index) in item.packageFilesList"
                fit="fill"
                :key="index"
                :src="imgItem.sUrl"
                @click="onImgPreview(imgItem.sUrl)"
                width="1.5rem"
                height="1.5rem"
                padding="0.2rem"
              />
              <footer class="card-footer">
                {{ $t('Package.箱数') }}：<span class="foot-desc">{{
                  item.iBags
                }}</span>
                <span class="pull-right">
                  {{ $t('Package.状态') }}：<span class="round-label">{{
                    pkgMap[item.istatus]
                  }}</span>
                </span>
              </footer>
            </template>
          </div>
        </section>
        <div class="pagination">
          <van-pagination
            @change="onSearch"
            v-model="currentPage"
            :total-items="totalCount"
            :items-per-page="limit"
            :show-page-size="4"
            force-ellipses
          />
        </div>
      </section>
      <section v-else class="padding no-item">
        <div class=""><img :src="emptyImg" /></div>
        <div class="nodesc">{{ $t('Package.暂时没有记录') }}</div>
      </section>
    </main>
  </div>
</template>
<script>
import { getPackageList, getStatsData } from '@/api/deliver.js';
import { BASE_TMS_URL, APP_TITLE } from '@/api/index.js';
import { $t } from '@/plugins/i18n';
import { getValidTime, getValidDate } from '@/utils/index.js';
import { ImagePreview } from 'vant';
import Vue from 'vue';
import { Image as VanImage } from 'vant';

Vue.use(VanImage);

export default {
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      appTitle: APP_TITLE,
      active: 0, //待入库
      keyword: '',
      list: [],
      emptyImg: require('@/assets/images/nopic.jpg'),
      userInfo: this.$store.getters.userInfo,
      tms_img_url: BASE_TMS_URL,
      startDate: '',
      endDate: '',
      totalCount: 0,
      currentPage: 1,
      limit: 15,
      state: -100,
      stats: {},
      bodyHeight: { height: '644px', overflow: 'auto' },
      pkgMap: {
        '-1': $t('Package.待入库'),
        0: $t('Package.已入库'),
        1: $t('Package.已发货'),
        2: $t('Package.待认领'),
        3: $t('Package.问题件'),
        '-10': $t('Package.全部包裹'),
      },
    };
  },
  computed: {
    title() {
      const q = this.$route.query;
      if (q.type === 'package') {
        let sta = q.status == 'outstock' ? -1 : q.status;
        return `${$t('Package.我的包裹')}-${this.pkgMap[sta]}`;
      }
      return $t('Package.我的包裹');
    },
  },
  mounted() {
    let hei = window.innerHeight - 176;
    this.bodyHeight.height = hei + 'px';
    const q = this.$route.query;
    var sta = q.status;
    sta = sta == 'outstock' ? -1 : sta;

    this.active = parseInt(sta) + 1;
    this.onSearch();
    this.loadData();
  },
  methods: {
    loadData() {
      this.$toast.loading();
      getStatsData({})
        .then(res => {
          this.stats = res;
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    onSearch() {
      const q = this.$route.query;
      var sta = q.status;
      sta = sta == 'outstock' ? -1 : sta;
      if (this.active == 0) {
        sta = -1;
      } else if (this.active == 1) {
        sta = 0;
      } else if (this.active == 2) {
        sta = 1;
      } else if (this.active == 3) {
        sta = 2; //待认领
      } else if (this.active == 4) {
        sta = 3; //问题件
      } else {
        sta = -10; //全部包裹
      }
      let offcount = (this.currentPage - 1) * this.limit;
      getPackageList({
        keyword: this.keyword,
        state: sta,
        startDate: this.startDate,
        endDate: this.endDate,
        limit: this.limit,
        offset: offcount,
      }).then(res => {
        res.rows.forEach(it => {
          it.createtime = getValidTime(it.createtime);
          if (it.dArriveTime != null) {
            it.dArriveTime = getValidDate(it.dArriveTime);
          }
          if (it.dDepartTime != null) {
            it.dDepartTime = getValidDate(it.dDepartTime);
          }
        });
        this.list = res.rows;
        this.totalCount = res.total;
      });
    },
    onImgPreview(imgurl) {
      if (imgurl == '' || imgurl == null) {
        return;
      }
      ImagePreview([imgurl]);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/_var';
.card {
  padding: rem(20px);
  padding-top: 0;
  border-radius: rem(15px);
  box-shadow: 0px 2px 10px 0px rgba(14, 48, 53, 0.1);
  background-color: #fff;
  .card-header {
    color: #b8b8b8;
    font-size: 12px;
    border-bottom: 1px solid #efefef;
    height: rem(53px);
    line-height: rem(53px);
  }
  .card-body {
    padding: rem(20px) 0;
    border-bottom: 1px solid #efefef;
    line-height: rem(52px);
  }
  .card-footer {
    color: #666;
    padding-top: rem(20px);
    height: rem(30px);
  }
  & + .card {
    margin-top: rem(20px);
  }
  .foot-desc {
    font-size: rem(32px);
    border-color: #673ab7;
    border: 1px solid;
    color: #673ab7;
    padding: 0 10px;
    border-radius: 4px;
    margin-right: 0.26rem;
  }
}
.padding {
  padding: rem(20px);
}
.date-input {
  border: 0;
}
.img {
  width: rem(280px);
  height: rem(150px);
  border: 1px solid #efefef;
  border-radius: 10px;
}
.noimg {
  width: auto;
  height: rem(150px);
}

.no-item {
  text-align: center;
  margin: rem(40px);
  img {
    height: rem(249px);
  }
  .no-desc {
    font-size: rem(13px);
    text-align: center;
  }
}
.van-image-qsoa {
  width: 90%;
  height: 90%;
  margin: 5px;
  border: 1px solid #b9aebb;
  img {
    border-radius: 10px;
  }
}
.round-label {
  background: #b9aebb;
  color: #fff;
  padding: 3px;
  border-radius: 3px;
  margin: 0 5px;
}
.order-info-item {
  border-color: #b9aebb;
  border: 1px solid;
  color: #b9aebb;
  padding: 0px 10px;
  border-radius: 4px;
  margin-right: rem(20px);
}
.pagination {
  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 40px;
  background: #efefef;
  border: 1px solid #efefef;
}
</style>
